import { toast } from 'sonner'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ModalPresetConfirm, ModalProps } from '@dashboard/ui'
import { dashboardClient } from '@/api'
import { CardTemplateRead } from '@/api/dashboard'
import { useGenerateCompanyPath } from '@/libs'
import { cardTemplatesQueryOpts } from '../api/cardTemplatesQueryOpts'
import 'prismjs/components/prism-json'
import 'prismjs/themes/prism.css'

interface CardTemplateDeleteModalProps extends ModalProps {
  cardTemplate: CardTemplateRead
}

export const CardTemplateDeleteModal = ({ cardTemplate, onClose, ...rest }: CardTemplateDeleteModalProps) => {
  const ql = useQueryClient()
  const { companyId, gameId } = useGenerateCompanyPath()

  const { mutateAsync: deleteCardTemplate } = useMutation({
    mutationFn: (id: string) => dashboardClient.v1.deleteCardTemplate(companyId, gameId, id),
    onSuccess: async () => {
      await ql.refetchQueries({ queryKey: cardTemplatesQueryOpts(companyId, gameId).queryKey })
      toast.success('Card template deleted')
    },
  })

  return (
    <ModalPresetConfirm
      {...rest}
      onClose={onClose}
      title={{
        children: 'Delete card template',
        subtitle: `Are you sure you want to delete the card template ${cardTemplate.card_type}?`,
      }}
      cancel={{
        label: 'Cancel',
        callback: onClose,
      }}
      submit={{
        label: 'Delete',
        callback: async () => {
          await deleteCardTemplate(cardTemplate.id)
          onClose(undefined, { closeAll: true })
        },
      }}
    />
  )
}
